module.exports = __webpack_public_path__ + "health-systems-leftlogos-retina___2qkai.png";